import React, { ReactNode } from 'react';
import { Classes, EventProps } from '../index';
import classNames from 'classnames';
import {
  getCaledarEventColorScheme,
  getCaledarEventCustomColor,
} from '../common/classes';
import { CalendarEventTooltip } from './CalendarEventTooltip';
import { Locale } from 'date-fns';

type EventComponentProps<ID> = {
  onEdit?: () => void;
  onDelete?: () => void;
  onClick?: () => void;
  event: EventProps<ID>;
  colorIndex?: number;
  selected?: boolean;
  locale: Locale;
  /**
   * Vlastní tooltip eventu
   * @param event
   */
  customEventTooltip?: (event?: EventProps<ID>) => ReactNode;
};

export const FullDayEvent = <ID extends unknown = {}>({
  onEdit,
  onDelete,
  colorIndex = 0,
  selected,
  onClick,
  locale,
  event,
  customEventTooltip,
}: EventComponentProps<ID>) => {
  return (
    <div
      style={{
        height: '100%',
      }}
      onClick={onClick}
    >
      <CalendarEventTooltip
        locale={locale}
        onEdit={onEdit}
        onDelete={onDelete}
        trigger={
          <div
            onDoubleClick={onEdit}
            className={classNames(
              Classes.CALENDAR_FULL_DAY_EVENT,
              getCaledarEventColorScheme(colorIndex),
              {
                [Classes.CALENDAR_EVENT_SELECTED]: selected,
                [getCaledarEventCustomColor(event.intent!)]: event?.intent,
                [Classes.CALEDNAR_EVENT_DISABLED]: event?.disabled,
                [Classes.CALEDNAR_EVENT_ENABLED]: !event?.disabled,
              }
            )}
          >
            <div className={Classes.CALENDAR_FULL_DAY_EVENT_TITLE}>
              {event.title}
            </div>
          </div>
        }
        event={event}
        customEventTooltip={customEventTooltip}
      />
    </div>
  );
};
